(() => {
  const setupDrawer = (root) => {
    const shell = root.querySelector("[data-alani-drawer-shell]");
    const button = root.querySelector("[data-alani-drawer-button]");
    if (!shell || !button) return;

    const closeButtons = shell.querySelectorAll("[data-alani-drawer-close]");

    const closeDrawer = () => {
      shell.classList.remove("is-open");
      button.setAttribute("aria-expanded", "false");
      document.documentElement.classList.remove("alaninu-drawer-open");
      document.body.classList.remove("alaninu-drawer-open");
    };

    const openDrawer = () => {
      shell.classList.add("is-open");
      button.setAttribute("aria-expanded", "true");
      document.documentElement.classList.add("alaninu-drawer-open");
      document.body.classList.add("alaninu-drawer-open");
    };

    button.addEventListener("click", () => {
      if (shell.classList.contains("is-open")) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener("click", closeDrawer);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && shell.classList.contains("is-open")) {
        closeDrawer();
      }
    });
  };

  const setupRail = (root) => {
    const viewport = root.querySelector("[data-alani-rail-viewport]");
    const track = root.querySelector("[data-alani-rail-track]");
    if (!viewport || !track) return;

    const prev = root.querySelector("[data-alani-rail-prev]");
    const next = root.querySelector("[data-alani-rail-next]");

    const getCardSize = () => {
      const card = track.querySelector("[data-alani-rail-card]");
      if (!card) return viewport.clientWidth * 0.9;
      const gap = parseFloat(getComputedStyle(track).gap || "0");
      return card.getBoundingClientRect().width + gap;
    };

    const updateButtons = () => {
      if (!prev || !next) return;
      const maxLeft = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      prev.disabled = viewport.scrollLeft <= 2;
      next.disabled = viewport.scrollLeft >= maxLeft;
    };

    if (prev && next) {
      prev.addEventListener("click", () => {
        viewport.scrollBy({ left: -getCardSize(), behavior: "smooth" });
      });

      next.addEventListener("click", () => {
        viewport.scrollBy({ left: getCardSize(), behavior: "smooth" });
      });
    }

    let isDragging = false;
    let startX = 0;
    let startLeft = 0;

    const pointerDown = (event) => {
      if (window.innerWidth < 990) return;
      isDragging = true;
      startX = event.clientX;
      startLeft = viewport.scrollLeft;
      viewport.classList.add("is-dragging");
    };

    const pointerMove = (event) => {
      if (!isDragging) return;
      event.preventDefault();
      const delta = event.clientX - startX;
      viewport.scrollLeft = startLeft - delta;
    };

    const pointerUp = () => {
      if (!isDragging) return;
      isDragging = false;
      viewport.classList.remove("is-dragging");
      updateButtons();
    };

    viewport.addEventListener("pointerdown", pointerDown);
    window.addEventListener("pointermove", pointerMove);
    window.addEventListener("pointerup", pointerUp);
    viewport.addEventListener("scroll", updateButtons, { passive: true });
    window.addEventListener("resize", updateButtons);

    track.querySelectorAll("[data-alani-rail-card]").forEach((card) => {
      const title = card.querySelector(".alaninu-rail-card__title")?.textContent?.trim().toLowerCase();
      const href = card.getAttribute("href") || "";
      if (title === "snacks" || href === "/collections/snacks") {
        card.setAttribute("href", "/collections/drinks-snacks");
      }
    });

    updateButtons();
  };

  const init = () => {
    document.querySelectorAll("[data-alani-header]").forEach(setupDrawer);
    document.querySelectorAll("[data-alani-rail]").forEach(setupRail);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
